<template>
  <v-tab-item>
    <v-layout row justify-center>
      <v-dialog
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        :value="filmrightDialogStatus"
      >
        <v-card>
          <v-toolbar class="yellow darken-4">
            <v-btn icon dark @click="filmrightDialogStatus = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{$t('rms.film.film_rights.dialog.header')}}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="text-xs-center my-2">
                <!-- FilmRight progress bar component -->
                <FilmRightProgress :film="film"></FilmRightProgress>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="my-2">
                <!-- FilmRight availaility and unavailibility component -->
                <FilmRightStatus :film="film"></FilmRightStatus>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-tab-item>
</template>

<script>
import FilmRightProgress from "@/components/filmrights/overview/Progress";
import FilmRightStatus from "@/components/filmrights/overview/Status";
export default {
  name:"FilmRightsInDetail",
  data() {
    return {
      active: null
    };
  },
  props: ["filmrights_dialog", "film"],
  components: {
    FilmRightProgress,
    FilmRightStatus
  },
  computed: {
    filmrightDialogStatus: {
      get() {
        return this.filmrights_dialog;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style>
</style>
